export const drivingLicenceHintKeys = {
  ACT: 'ident_document.driving_licence.hint.numeric_6_10',
  NT: 'ident_document.driving_licence.hint.numeric_6_10',
  QLD: 'ident_document.driving_licence.hint.numeric_8_9',
  NSW: 'ident_document.driving_licence.hint.alphanumeric_6_8',
  SA: 'ident_document.driving_licence.hint.alphanumeric_6',
  TAS: 'ident_document.driving_licence.hint.alphanumeric_6_8',
  VIC: 'ident_document.driving_licence.hint.numeric_6_10',
  WA: 'ident_document.driving_licence.hint.numeric_7',
};

const numeric = (min, max) => new RegExp(`^\\d{${min},${max}}$`);
const alphanumeric = (min, max) => new RegExp(`^[A-Za-z0-9]{${min},${max}}$`);

export const drivingLicenceRules = {
  ACT: { pattern: numeric(6, 10), message: 'errors.field.drivingLicenceNumber.ACT', maxCharacters: 10 },
  NT: { pattern: numeric(6, 10), message: 'errors.field.drivingLicenceNumber.NT', maxCharacters: 10 },
  QLD: { pattern: numeric(8, 9), message: 'errors.field.drivingLicenceNumber.QLD', maxCharacters: 9 },
  NSW: { pattern: alphanumeric(6, 8), message: 'errors.field.drivingLicenceNumber.NSW', maxCharacters: 8 },
  SA: { pattern: alphanumeric(6, 6), message: 'errors.field.drivingLicenceNumber.SA', maxCharacters: 6 },
  TAS: { pattern: alphanumeric(6, 8), message: 'errors.field.drivingLicenceNumber.TAS', maxCharacters: 8 },
  VIC: { pattern: numeric(6, 10), message: 'errors.field.drivingLicenceNumber.VIC', maxCharacters: 10 },
  WA: { pattern: numeric(7, 7), message: 'errors.field.drivingLicenceNumber.WA', maxCharacters: 7 },
};
